import React, { useEffect, useState } from 'react'
import Filters from './Filters'
import '../../styles/scheduletab.scss'
import Rounds from './Rounds'
import WeekCalendar from './WeekCalendar'
import Practices from './Practices'
import ConstraintsList from './ConstraintsList'
import AddConstraintModal from '../Modals/Detail/AddConstraintModal'
import { leagueEventStore } from 'state/league/leagueEvent'
import { useGetLeagueGames } from 'api/league/leagueGames/leagueGames'
import moment from 'moment'

export type ViewMode = 'week' | 'day'
type ScheduleTab = 'games' | 'practices' | 'constraints'

const Schedule: React.FC = () => {
  const { leagueData, addTeamConstraintModal } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    addTeamConstraintModal: store.addTeamConstraintModal,
  }))
  const [weekStart, setWeekStart] = useState(moment().startOf('isoWeek'))
  const [viewMode, setViewMode] = useState<ViewMode>('week')
  const [activeTab, setActiveTab] = useState<ScheduleTab>('games')

  const {
    data: gamesByLeagueId,
    isLoading: gamesLoading,
    isFetching: gamesFetching,
    refetch,
  } = useGetLeagueGames({ leagueId: leagueData._id })

  useEffect(() => {
    refetch()
  }, [viewMode])

  return (
    <>
      <div className="py-5px bg-dark-gray"></div>
      <div className="schedule-main-container">
        <Filters
          weekStart={weekStart}
          setWeekStart={setWeekStart}
          viewMode={viewMode}
          setViewMode={setViewMode}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />

        {activeTab === 'games' && (
          <>
            {viewMode === 'week' ? (
              <WeekCalendar
                games={gamesByLeagueId}
                weekStart={weekStart}
                isLoading={gamesLoading || gamesFetching}
              />
            ) : (
              <Rounds />
            )}
          </>
        )}
        {activeTab === 'practices' && <Practices />}
        {activeTab === 'constraints' && <ConstraintsList />}
      </div>

      {addTeamConstraintModal && <AddConstraintModal />}
    </>
  )
}

export default Schedule
